<ngx-gov-co-shd-app-header [menuElements]="[]" [invisibleMenu]="[]"></ngx-gov-co-shd-app-header>

<main class="form-container" *ngIf="showViewHTMLComponent">
  <div class="contenedor-grid">
    <div class="container-app-carrusel-impuestos">
      <div class="register-info__title1">
        Gestiona tus impuestos de forma segura y garantizada
      </div>
      <div class="register-info__content1">
        Regístrate en la Oficina Virtual para acceder en línea a tus impuestos distritales: realiza pagos, descarga facturas, presenta declaraciones, obtén certificados y más de tus transacciones tributarias, al instante.
      </div>
      <div class="register-info__title2--wrapper">
        <div class="register-info__icon">
          <div class="simple-banner-component simple-banner center-block">
            <img title="Register info icon" alt="Register info icon" src="assets/icons/register-info-icon.png">
          </div>
        </div>
        <div class="register-info__title2">
            ¡Ten en cuenta!
        </div>
      </div>
      <div class="register-info__content2">
        Los impuestos que actualmente puedes tramitar a través de la Oficina Virtual son estos:
        <ul>
          <li>
            <span>Impuesto de Industria y Comercio</span>
          </li>
          <li>
            <span>Retención del ICA (ReteICA)</span>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <form [formGroup]="formLogin">
        <!-- Encabezado -->
        <header class="header-section" style="margin-top: 10px;margin-bottom: 10px;padding-top: 10px;">
          <div class="container header-container-">
            <h1>Inicio de sesión</h1>
            <p class="p-title">Ingresa tus credenciales para continuar</p>
          </div>
        </header>
        <div class="container section">
          <div class="section_container_2">
            <div class="row form-gap-row">
              <div class="form-field">
                <label for="tipoDocumento" class="form-required">Tipo de documento</label>
                <select class="form-select" formControlName="tipoDocumento" name="tipoDocumento" id="tipoDocumento"
                  (change)="validarTipoDocumento(true)">
                  <option value="">Selecciona una opción</option>
                  <option *ngFor="let item of tiposDocumentos" [ngValue]="item.cod">{{item.desc}}</option>
                </select>
                <span class="form-field__status error"
                  *ngIf="formLogin.get('tipoDocumento')?.touched && this.formLogin.get('tipoDocumento')?.errors?.['required']">
                  {{PARAMETRIZACION_FORMULARIO_LOGIN.tipoDocumento.required.mensaje}}
                </span>
              </div>
              <div class="form-field">
                <label for="numeroDocumento" class="form-required">Número de documento</label>
                <input type="text" placeholder="Escriba la información solicitada" class="lowerCase form-control"
                  id="numeroDocumento" name="numeroDocumento" formControlName="numeroDocumento" autocomplete="off">
                <span class="form-field__status error"
                  *ngIf="formLogin.get('numeroDocumento')?.touched && this.formLogin.get('numeroDocumento')?.errors?.['required']">
                  {{PARAMETRIZACION_FORMULARIO_LOGIN.numeroDocumento.required.mensaje}}
                </span>
                <span class="form-field__status error"
                  *ngIf="(this.formLogin.get('numeroDocumento')?.touched || this.formLogin.get('numeroDocumento')?.dirty) && this.formLogin.get('numeroDocumento')?.errors?.['pattern']">
                  {{validarTipoDocumento()}}
                </span>
                <span class="form-field__status info" *ngIf="this.formLogin.get('tipoDocumento')?.value == 'NIT'">
                  {{'Ingrese el número de documento sin dígito de verificación'}}
                </span>
              </div>
              <div class="form-field">
                <div class="form-group" >
                  <label for="clave" class="form-required">Contraseña</label>
                  <div class="password-container">
                    <input 
                      [type]="passwordVisible ? 'text' : 'password'"
                       placeholder="Escriba la información solicitada" 
                      class="password-input"
                      id="clave" name="clave" formControlName="clave"
                      autocomplete="off"
                    >
                    <button 
                      type="button" 
                      class="toggle-password-btn" 
                      (click)="togglePasswordVisibility()"
                    >
                      <span class="material-symbols-outlined material-symbols-filled icon-password-color">
                        {{ !passwordVisible ? 'visibility_off' : 'visibility' }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-field">
                <div class="captcha-wrapper">
                  <div class="contenedor-cap">
                    <app-recaptcha [siteKey]="siteKeyCatchap" (recaptchaSuccess)="onRecaptchaSuccess($event)"
                      (recaptchaExpired)="onRecaptchaExpired()" (recaptchaError)="onRecaptchaError()">
                    </app-recaptcha>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="container-left">
                  <button type="button" class="btn submit-btn btn-login" (click)="autenticarse()" [disabled]="!isValid()">
                    INICIAR SESIÓN
                  </button>
                </div>
            </div>
            <div class="container-left">
              <div class="row">
                <div class="container-registrarse">
                  <p class="text-simple">¿No tienes cuenta?</p>
                  <a class="text-simple" [href]="this.linksAyuda.urlAuti" *ngIf="this.linksAyuda.urlAuti" target="_blank">Regístrate aquí</a>
                </div>
                <a class="text-simple" [href]="this.linksAyuda.urlRecuperarClave" *ngIf="this.linksAyuda.urlRecuperarClave" target="_blank">Olvidé mi contraseña</a>
                <a class="text-simple" [href]="this.linksAyuda.urlCambiaCorreo" *ngIf="this.linksAyuda.urlCambiaCorreo" target="_blank">Cambiar correo electrónico</a>
                <a class="text-simple" [href]="this.urlInstructivos" *ngIf="this.urlInstructivos" target="_blank">Instructivos Oficina Virtual</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="info-section__container">
    <div class="info-section__icon">
    <div class="simple-banner-component simple-banner center-block">
      <img title="Info section icon" alt="Info section icon" src="assets/icons/info-section-icon.png">
      </div>
    </div>
      
    <div class="info-section__text">
      <div class="content">Si deseas más información sobre la Secretaría de Hacienda de Bogotá, consulta nuestra sede electrónica.</div></div>
      <div class="info-section__link">
          <a class="info-section__link--text" target="_blank" href="https://www.haciendabogota.gov.co/">
              IR AL SITIO WEB</a>
          <span>
              <img src="assets/icons/info-section-arrow-icon.svg">
          </span>
      </div>
  </div>
</main>
<app-modal></app-modal>

<ngx-gov-co-shd-app-footer></ngx-gov-co-shd-app-footer>